import {
  DisplayFormErrors,
  InputField,
  ControlcenterMelcoModelsSupplierProduct,
  VerticalForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { QueryObserverResult } from "react-query";
import { FullWidthSpace } from "melco-ui";
import { SavePublishHeader } from "../../header/SavePublishHeader";
import { DebugForm } from "../../form/DebugForm";
import { useRevertSupplierProduct } from "../../../hooks/supplierproducts/useRevertSupplierProduct";

type DisplaySupplierProductEditFormProps = {
  supplierProduct: ControlcenterMelcoModelsSupplierProduct;
  refetch: () => Promise<
    QueryObserverResult<ControlcenterMelcoModelsSupplierProduct, unknown>
  >;
};

export const DisplaySupplierProductEditForm: React.FC<
  DisplaySupplierProductEditFormProps
> = ({ supplierProduct, refetch }) => {
  const {
    id,
    publish_state: publishState,
    created_date: createdDate,
    updated_date: updatedDate,
    publish_date: publishDate,
    warning_list: warningList,
  } = supplierProduct;

  const { t } = useTranslation();
  const [revertSupplierProduct, isLoading] = useRevertSupplierProduct(
    id!,
    refetch
  );

  return (
    <>
      <SavePublishHeader
        revertAction={revertSupplierProduct}
        isCurrentlyReverting={isLoading}
        publishedState={publishState!}
        createdDate={createdDate!}
        updatedDate={updatedDate}
        publishedDate={publishDate}
        warnings={warningList ?? undefined}
      />

      <VerticalForm>
        <FullWidthSpace direction="vertical">
          <div>
            <DisplayFormErrors />

            <InputField
              name="supplier_name"
              label={t("supplierproducts.form.supplier")}
              disabled
              readOnly
            />
            <InputField name="name" label={t("supplierproducts.form.name")} />
            <InputField name="code" label={t("supplierproducts.form.code")} />
          </div>
        </FullWidthSpace>
      </VerticalForm>

      {false && <DebugForm />}
    </>
  );
};
